import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";
import checkIconRed from "../../../resources/images/alert-circle.svg";

const styles = createUseStyles(theme => ({
  modalContent: {
    margin: "20px 0 0 0"
  },
  inputWrapperStyling: {
    "& span": {
      top: "10px",
    }
  },
  details: {
    fontSize: "14px",
    fontWeight:"400",
    lineHeight:"20px",
    "& span": {
      fontWeight:"600",
      color: colors.lightBlack
    }
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    marginTop: 0,
  },
  assignTo: {
    fontSize: "14px",
    fontWeight:"500",
    lineHeight: "20px",
    color: colors.grey
  },
  autocompleteOptions: {
    position: "sticky",
    alignContent: "center",
    background: colors.white,
    borderTop: "1px solid " + colors.lightGrey,
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    width: "100%",
    padding: "12px 10px 12px 10px",
    color: colors.mediumGrey,
    maxHeight: "230px",
    overflowY: "auto",
    boxShadow:
      "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    overflowX: "hidden",
    "& ::-webkit-scrollbar": {
      width: "12px",
    },
    "& p": {
      display: "flex",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: "400",
      padding: "8px",
      minHeight: "44px",
      margin: 0,
      wordWrap: "wrap",
    },
    "& ul": {
      margin: "-8px -6px -8px -6px",
      padding: "0px",
    },
    "& li": {
      display: "flex",
      alignItems: "center",
      listStyleType: "none",
      padding: "14px 14px",
      minHeight: "44px",
      fontSize: "16px",
      fontWeight: "500",
      borderRadius: "6px",
      color: colors.lightBlack,
      "&:hover": {
        background: colors.brightBlue,
      },
    },
  },
  selectedUser: {
    display: "flex",
    justifyContent: "space-between"
  },
  userDetails: {
    display: "flex"
  },
  userDiv: {
    marginLeft: "14px",
  },
  name: {
    color: colors.lightBlack,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
  },
  email: {
    color: colors.mediumGrey,
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
  },
  profileAvatar: {
    alignSelf: "center",
    minWidth: "40px",
    minHeight: "40px",
    color: colors.mediumGrey,
    fontSize: "16px",
    fontWeight:"500",
    lineHeight:"24px",
    background: colors.veryLightGrey,
    borderRadius: "200px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& span": {
      color: colors.white
    }
  },
  travelCreditsAssignModal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight:"600",
      lineHeight:"28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight:"400",
      lineHeight:"20px",
    },
    "& .modal-body": {
      padding: "8px 24px",

    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  btnContainer:{
    marginTop:"32px",
    marginBottom:"16px"
  },


  cancelBtn: {
    height: "100%",
    alignItems: "center",
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  continueBtn: {
    height: "100%",
    alignItems: "center",
    width:"100%",
    backgroundColor: colors.darkBlue,
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  colCancel:{
    padding:"0px",
    marginRight:"6px"
  },
  colContinue:{
    padding:"0px",
    marginLeft:"6px"
  }
}));

export default styles;